var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileSplash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 403,
    viewBox: "0 0 311 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.073,
    cy: 364.916,
    rx: 155.045,
    ry: 155.045,
    transform: "rotate(90 155.073 364.916)",
    fill: "#1D41FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.927 309.59C70.5745 309.59 1.38244 240.398 1.38244 155.045C1.38244 69.6921 70.5745 0.499989 155.927 0.499993C241.28 0.499997 310.472 69.6921 310.472 155.045C310.472 240.398 241.28 309.59 155.927 309.59Z",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSplash);
export default __webpack_public_path__ + "static/media/mobile-splash.749b56a2be8da1beea8267a9954fd175.svg";
export { ForwardRef as ReactComponent };